<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" @click="addTeamStatus=true" size="mini">新建项目组</el-button>
      </div>
      <!-- <label class="label-name">所属公司：</label>
      <el-select size="small" class="organization-select" v-model="depId" placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select> -->
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="name" label="项目组名称">
      </el-table-column>
      <el-table-column label="所属公司">
        <template slot-scope="scope">
          {{ teamGroup[scope.row.type].name }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="deleteTeam(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>


    <!-- 添加项目组 -->
    <div class="pop-room" v-if="addTeamStatus">
      <a href="javascript:;" @click="addTeamStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="所属公司">
              <el-select size="small" class="organization-select" v-model="form.type" placeholder="请选择所属公司">
                <el-option v-for="item in teamGroup" :key="item.type" :label="item.name" :value="item.type">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目组名称">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="addTeam()" class="form-btn" type="success">确认添加项目组</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,

        addTeamStatus: false,

        teamGroup: [{
            type: 0,
            name: "水务集团(公用)"
          },
          {
            type: 1,
            name: "自来水公司"
          },
          {
            type: 2,
            name: "原水公司"
          },
          {
            type: 3,
            name: "污水公司"
          },
          {
            type: 4,
            name: "水建公司"
          }
        ],

        form: {
          depId: '',
          name: ""
        },

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.organizationListData[0].id

      // 获取列表
      this.getLists()
    },
    components: {},
    methods: {
      addTeam() {
        if (!this.form.name) {
          this.$message.error("项目组名称不能为空")
          return
        }
        ajax.post('/gc/project/team/add', this.form, (res) => {
          this.$message.success("添加项目组成功")
          this.getLists()
          this.addTeamStatus = false
        })
      },
      deleteTeam(row) {
        this.$confirm('此操作将永久删除该项目组, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/gc/project/team/del', {
            teamId: row.id
          }, (res) => {
            this.$message.success("删除项目组成功")
            this.getLists()
          })
        }).catch(() => {});
      },
      startCreate() {
        this.$router.push("/Meeting/Create")
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.post('/gc/project/team/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'depId'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/project/teamlist.vue